import React from "react";
import { NodeViewWrapper } from "@tiptap/react";
import AutoGrowInput from "./AutoGrowInput";

/**
 * NodeView درون‌خطی رادیکال — مثل Equation ورد.
 *
 * ساختار flex: [فرجه؟] [SVG رادیکال] [عبارت با خط بالایی کامل (border-top کشیده)]
 * خط بالایی (vinculum) با border-top روی کانتینر عبارت تعریف شده
 * تا به هر طولی که زیر رادیکال تایپ شود، خط بالا ۱۰۰٪ روی آن کشیده شود.
 */
const SqrtNodeView = ({ node, updateAttributes, selected }) => {
  const { radicand = "", degree = "" } = node.attrs;
  const isNth = node.type.name === "nthRoot";

  return (
    <NodeViewWrapper
      as="span"
      className={`relative inline-block align-middle mx-1 rounded transition-all ${
        selected ? "bg-blue-50/40 ring-2 ring-blue-400" : ""
      }`}
      style={{ direction: "ltr", unicodeBidi: "isolate" }}
    >
      <span
        className="inline-flex items-stretch"
        contentEditable={false}
        style={{ direction: "ltr", fontSize: "0.9em" }}
      >
        {isNth && (
          <AutoGrowInput
            value={degree}
            onCommit={(v) => updateAttributes({ degree: v })}
            aria-label="فرجه"
            className="self-end mb-2 border-b border-slate-500 focus:border-blue-400"
            style={{ fontSize: "0.7em", marginRight: "-2px" }}
          />
        )}

        {/* علامت V رادیکال */}
        <svg
          viewBox="0 0 11 22"
          preserveAspectRatio="none"
          aria-hidden="true"
          style={{
            width: "11px",
            display: "block",
            alignSelf: "stretch",
            flexShrink: 0,
          }}
        >
          <path
            d="M 1 12 L 3.5 11 L 6 21 L 10.5 0.9"
            fill="none"
            stroke="#334155"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
        </svg>

        {/* خط بالای رادیکال و محتوای زیر آن — با borderTop کامل روی کل عبارت */}
        <span
          className="relative inline-flex items-center"
          style={{
            borderTop: "1.8px solid #334155",
            paddingTop: "2px",
            paddingLeft: "3px",
            paddingRight: "3px",
          }}
        >
          <AutoGrowInput
            value={radicand}
            onCommit={(v) => updateAttributes({ radicand: v })}
            aria-label="زیر رادیکال"
          />
        </span>
      </span>
    </NodeViewWrapper>
  );
};

export default SqrtNodeView;
